/**
 * Где физически лежат файлы документов.
 *
 * Смысл хранилища — пути, размеры, поиск осиротевших — живёт **выше**, в `store.ts`,
 * и не знает, куда именно пишутся байты. Реализаций три: OPFS (настоящие файлы),
 * IndexedDB (там, где OPFS нет — это iOS 16) и память для тестов. Правила при этом
 * проверяются один раз, а не трижды.
 */
export interface BlobBackend {
  /** Как называется это хранилище — показывается юристу в разделе «Хранилище». */
  readonly kind: 'opfs' | 'indexeddb' | 'memory';

  write(path: string, blob: Blob): Promise<void>;
  read(path: string): Promise<Blob | null>;
  remove(path: string): Promise<void>;

  /** Все пути, начинающиеся с [prefix], вместе с размерами. */
  list(prefix: string): Promise<{ path: string; sizeBytes: number }[]>;
}

/** Путь файла документа: `cases/<дело>/<документ>.<расширение>` — как в ARCHITECTURE.md. */
export const casePath = (caseId: string, fileName: string) => `cases/${caseId}/${fileName}`;

export const CASES_PREFIX = 'cases/';
